import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";
import CircularProgress from "@material-ui/core/CircularProgress";

import Swal from "sweetalert2";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";
import AddUpdateSpecialDates from "./AddUpdateSpecialDates";
import AdminLayout from "../AdminLayout";

const SpecialDates = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    date: "",
    short_description: "",
    notes: "",
    id: -1,
  });
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API}/admin/specialDates/get`)
      .then((response) => {
        setData(response.data);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        toast.error("Error loading Data");
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const addForm = () => {
    setFormData({
      customer_id: null,
      date: "",
      short_description: "",
      notes: "",
      id: -1,
    });
    setVisible(true);
  };

  const updateForm = (meta) => {
    const id = meta.rowData[0];
    axios
      .get(`${process.env.REACT_APP_API}/admin/specialDates/getById/${id}`)
      .then((response) => {
        setFormData({
          customer_id: response.data.customer_id,
          date: response.data.date,
          short_description: response.data.short_description,
          notes: response.data.notes,
          id: id,
        });
        setVisible(true);
      })
      .catch(() => {
        toast.error("Error");
      });
  };

  const deleteForm = (meta) => {
    const id = meta.rowData[0];
    Swal.fire({
      title: "Please Confirm Your Action?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      icon: "warning",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(`${process.env.REACT_APP_API}/admin/specialDates/delete`, {
            id,
          })
          .then(() => {
            toast.success("Deleted successfully");
            getData();
          })
          .catch(() => {
            toast.error("Error");
          });
      }
    });
  };

  const columns = [
    { name: "id", label: "ID" },
    {
      name: "customer",
      label: "Customer",
      options: {
        customBodyRenderLite: (dataIndex) => {
          const row = data[dataIndex];
          return `${row.first_name} ${row.last_name}`;
        },
      },
    },
    { name: "date", label: "Date" },
    { name: "short_description", label: "Short Description" },
    { name: "notes", label: "Notes" },
    {
      name: "actions",
      label: "Actions",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (_, meta) => (
          <div>
            <button
              className="btn btn-primary mx-1"
              onClick={() => updateForm(meta)}
            >
              Update
            </button>
            <button
              className="btn btn-danger mx-1"
              onClick={() => deleteForm(meta)}
            >
              Delete
            </button>
          </div>
        ),
      },
    },
  ];

  const options = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",
    customToolbar: () => (
      <Tooltip title="Add">
        <IconButton onClick={addForm}>
          <AddIcon />
        </IconButton>
      </Tooltip>
    ),
    textLabels: {
      body: {
        noMatch: isLoading ? (
          <CircularProgress />
        ) : (
          "There is no matching data to display"
        ),
      },
    },
  };

  return (
    <AdminLayout>
      <div className="container">
        <CustomMuiDataTable
          title="Special Dates"
          data={data}
          columns={columns}
          options={options}
        />
        <AddUpdateSpecialDates
          visible={visible}
          setVisible={setVisible}
          formData={formData}
          setFormData={setFormData}
          getData={getData}
        />
      </div>
    </AdminLayout>
  );
};

export default SpecialDates;
